import { render } from "./GlobalWarmingAnimation.vue?vue&type=template&id=9884e4d6&scoped=true&ts=true"
import script from "./GlobalWarmingAnimation.vue?vue&type=script&lang=ts"
export * from "./GlobalWarmingAnimation.vue?vue&type=script&lang=ts"

import "./GlobalWarmingAnimation.vue?vue&type=style&index=0&id=9884e4d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9884e4d6"]])

export default __exports__